import { BackendStock } from 'types/backendPdp'

// Public env var since this runs in the browser. The build-time fetcher
// (fetchStockKeysByHandle.ts) reads the same one — the site is a static
// export, so there's no server-only host to keep separate.
const BACKEND_CATALOG_API_URL = process.env.NEXT_PUBLIC_BACKEND_CATALOG_API_URL

// Runtime availability for every colour and silhouette in one family,
// fetched client-side. One of the few routes open to browser origins via
// CORS; response is edge-cached for ~60s. Throws rather than reporting
// here — the calling SWR hook's onError is the single place that does,
// matching how the CAS inventory fetch reports.
//
// The slug can also be the handle of any of the family's pages, for callers
// (the basket) that only know the page. A market gives that store's variants.
export async function fetchFamilyStock(
  familySlug: string,
  market?: string
): Promise<BackendStock> {
  if (!BACKEND_CATALOG_API_URL) {
    throw new Error(
      'NEXT_PUBLIC_BACKEND_CATALOG_API_URL is not set — see spokeldn/backend README for the staging/production host'
    )
  }

  const query = market ? `?market=${market}` : ''
  const response = await fetch(
    `${BACKEND_CATALOG_API_URL}/products/${familySlug}/stock${query}`,
    {
      signal: AbortSignal.timeout(15_000)
    }
  )

  if (!response.ok) {
    throw new Error(
      `GET /products/${familySlug}/stock${query} responded ${response.status}`
    )
  }

  return (await response.json()) as BackendStock
}
